import homeBlockItem from './home-block-item';

export default class HomeProduct extends homeBlockItem{
    constructor(data) {
        super(data);

        this.mubParent = null;
        this.mubItemsVp = null;
        this.mubItemsTotal = null;
    }

    get key(){
        return this.sku;
    }

    get type(){
        return 'product';
    }

    get mubData(){
        if(!this.mubParent){
            return null;
        }

        let mub = this.mubParent;
        if(!mub.hasOwnProperty('m')){
            mub.m = {};
        }
        mub.m.id = this.id;
        mub.m.itemsVp = this.mubItemsVp;
        mub.m.itemsTotal = this.mubItemsTotal;
        return JSON.stringify(mub);
    }

    setMubParent(data, itemsVp, itemsTotal){
        this.mubParent = data && typeof data === 'object' ? data : null;
        this.mubItemsVp = itemsVp;
        this.mubItemsTotal = itemsTotal;
    }
}